import { useState } from 'react';
import {
    featureFlagService,
    ActiveFlags,
} from 'helpers/featureFlagsService/feature-flag-service';
import { FeatureFlag } from 'types/enums';
import { EventObserver } from 'utils';
import useMountEffect from 'hooks/useMountEffect';

export function useFlag(
    flag: FeatureFlag,
    isDefaultFlagsAllowed = true,
): boolean | undefined {
    const [hasFetchedFF, setHasFetchedFF] = useState(false);
    const [flags, setFlags] = useState<Partial<ActiveFlags>>(
        featureFlagService.get(),
    );

    useMountEffect(() => {
        async function getHasFetchedFF() {
            const response = await featureFlagService.load();

            setHasFetchedFF(response);
        }

        getHasFetchedFF();
    });

    useMountEffect(() => {
        const observer = new EventObserver((data: Partial<ActiveFlags>) =>
            setFlags(data),
        );

        featureFlagService.subscribe(observer);

        return () => featureFlagService.unsubscribe(observer);
    });

    const canFlagBeReturned = isDefaultFlagsAllowed || hasFetchedFF;

    return canFlagBeReturned ? !!flags[flag] : undefined;
}
